import type { FaireProductEntity } from "../../entity_types/product";

export const p_my63jptwvq: FaireProductEntity = {
  token: "p_my63jptwvq",
  type: "product",
  name: "53 in H Metal Decorative Garden Birdhouse",
  brandName: "Glitzhome",
  imageUrl:
    "https://cdn.faire.com/fastly/4d847ebe25faea172312964b2d9b0df3b6a6b99d316ab56f6b0e3827f58d142b.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7501aacad42f72e82cebf2d7a479cf24a804509bfe04fdf30107582694d31716.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
